import React from "react";
import { Box } from "@mui/material";
import { useStoreState } from "app/state/store/hooks";
import { getHeaderButtonItems } from "../header/sub-components/buttons/data";
import { useCMSData } from "app/hooks/useCMSData";

const LoginFlowBackdrop = () => {
  const loginFlow = useStoreState(
    (state) => state.activeHeaderButton.loginFlow
  );
  const actionButton = useStoreState(
    (state) => state.activeHeaderButton.activeButton
  );

  const cmsData = useCMSData({ returnData: true });

  const HEADER_BUTTON_ITEMS = React.useMemo(
    () => getHeaderButtonItems(cmsData),
    [cmsData]
  );

  const showBackDrop = React.useMemo(() => {
    if (loginFlow.showTooltip && actionButton === HEADER_BUTTON_ITEMS[4].key) {
      return true;
    }
    return false;
  }, [loginFlow, actionButton, HEADER_BUTTON_ITEMS]);

  return (
    <React.Fragment>
      {showBackDrop ? (
        <Box
          sx={{
            background: "rgba(12, 22, 42, 0.30)",
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: 1301,
          }}
        />
      ) : null}
    </React.Fragment>
  );
};

export default LoginFlowBackdrop;
